var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_piggycell_80px",
    transform: "translate(-792 -944)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_50",
    "data-name": "\\uD0C0\\uC6D0 50",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(792 944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_233",
    "data-name": "\\uADF8\\uB8F9 233",
    transform: "translate(318.952 771.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_227",
    "data-name": "\\uADF8\\uB8F9 227",
    transform: "translate(500.54 233.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_531",
    "data-name": "\\uD328\\uC2A4 531",
    d: "M538.874,478.01c0,.643-2.166.81-4.838.81-.408,0-.8,0-1.182-.01a4.2,4.2,0,0,1,.119-.746,2.5,2.5,0,0,0-1.265.708c-1.5-.082-2.512-.284-2.512-.763,0-1.229,2.166-2.223,4.84-2.223S538.874,476.781,538.874,478.01Z",
    transform: "translate(-529.196 -475.787)",
    fill: "#a6b1b5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path__V002",
    "data-name": "<Path>_V002",
    d: "M538.874,478.01c0,.643-2.166.81-4.838.81-.408,0-.8,0-1.182-.01.019-.651.409-1.385-.028-1.385a1.648,1.648,0,0,0-1.118,1.348c-1.5-.082-2.512-.284-2.512-.763,0-1.229,2.166-2.223,4.84-2.223S538.874,476.781,538.874,478.01Z",
    transform: "translate(-28.656 -241.963)",
    fill: "#f0f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path__V002-2",
    "data-name": "<Path>_V002",
    d: "M540.1,482.3c0,.476-1.716.6-3.833.6-.322,0-.4,0-.7-.009.015-.483.441-1.492-.13-1.369a1.949,1.949,0,0,0-1.017,1.341c-1.185-.059-1.988-.21-1.988-.565,0-.912,1.715-1.651,3.832-1.651S540.1,481.384,540.1,482.3Z",
    transform: "translate(-31.378 -246.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Outline",
    d: "M530.946,472.7c2.673,0,4.838.994,4.838,2.223,0,.643-2.166.81-4.838.81-.408,0-.8,0-1.182-.01.019-.651.409-1.385-.028-1.385a1.648,1.648,0,0,0-1.118,1.348c-1.5-.082-2.512-.284-2.512-.763,0-1.229,2.166-2.223,4.84-2.223m0-.592c-3.1,0-5.432,1.21-5.432,2.815,0,1.1,1.586,1.273,3.071,1.354l.5.027.074-.343-.01.341.6.013c.383.008.782.01,1.2.01,4.06,0,5.431-.354,5.431-1.4,0-1.6-2.335-2.815-5.431-2.815Z",
    transform: "translate(-25.566 -238.873)",
    fill: "#1cb1e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_228",
    "data-name": "\\uADF8\\uB8F9 228",
    transform: "translate(512.911 233.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_532",
    "data-name": "\\uD328\\uC2A4 532",
    d: "M606.112,478.01c0,.643,2.167.81,4.839.81.408,0,.8,0,1.182-.01a4.286,4.286,0,0,0-.119-.746,2.5,2.5,0,0,1,1.264.708c1.5-.082,2.512-.284,2.512-.763,0-1.229-2.167-2.223-4.839-2.223S606.112,476.781,606.112,478.01Z",
    transform: "translate(-606.112 -475.787)",
    fill: "#a6b1b5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path__V002-3",
    "data-name": "<Path>_V002",
    d: "M606.112,478.01c0,.643,2.167.81,4.839.81.408,0,.8,0,1.182-.01-.019-.651-.409-1.385.029-1.385a1.648,1.648,0,0,1,1.117,1.348c1.5-.082,2.512-.284,2.512-.763,0-1.229-2.167-2.223-4.839-2.223S606.112,476.781,606.112,478.01Z",
    transform: "translate(-93.201 -241.963)",
    fill: "#f0f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path__V002-4",
    "data-name": "<Path>_V002",
    d: "M615.391,482.3c0,.476,1.715.6,3.832.6.322,0,.4,0,.7-.009-.015-.483-.441-1.492.13-1.369a1.946,1.946,0,0,1,1.017,1.341c1.185-.059,1.989-.21,1.989-.565,0-.912-1.716-1.651-3.832-1.651S615.391,481.384,615.391,482.3Z",
    transform: "translate(-100.988 -246.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Outline-2",
    "data-name": "Outline",
    d: "M607.86,472.7c2.672,0,4.84.994,4.84,2.223,0,.479-1.014.681-2.512.763a1.648,1.648,0,0,0-1.117-1.348c-.438,0-.047.734-.028,1.385-.378.008-.775.01-1.182.01-2.672,0-4.839-.168-4.839-.81,0-1.229,2.167-2.223,4.839-2.223m0-.592c-3.1,0-5.431,1.21-5.431,2.815,0,1.048,1.37,1.4,5.431,1.4.413,0,.813,0,1.2-.01l.6-.013-.01-.338.074.34.5-.027c1.486-.081,3.072-.259,3.072-1.354,0-1.6-2.335-2.815-5.432-2.815Z",
    transform: "translate(-90.111 -238.873)",
    fill: "#1cb1e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_533",
    "data-name": "\\uD328\\uC2A4 533",
    d: "M660.244,222.143a.272.272,0,0,0,.02-.063.19.19,0,0,0-.163-.213.182.182,0,0,0-.139.038l-4.333,3.858-.319-2.032-5.562,4.812.678,1.64L654.6,225.8l.392,2.424,5.21-6.015Z",
    transform: "translate(-129.819 -28.881)",
    fill: "#fcab00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_229",
    "data-name": "\\uADF8\\uB8F9 229",
    transform: "translate(501.234 187.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_534",
    "data-name": "\\uD328\\uC2A4 534",
    d: "M547.12,191.429l-3.241,7.9-2.138.808,5.053-8.914a.189.189,0,0,1,.352.1.177.177,0,0,1-.013.065Z",
    transform: "translate(-540.418 -190.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_535",
    "data-name": "\\uD328\\uC2A4 535",
    d: "M540.052,188.042a.189.189,0,0,1,.189.189.177.177,0,0,1-.013.065l-.012.043-3.241,7.9-2.138.808,5.053-8.914a.188.188,0,0,1,.162-.093m0-.592a.784.784,0,0,0-.673.384l-5.058,8.924-.808,1.425,1.533-.579,2.138-.808.241-.091.1-.238,3.242-7.9.013-.03.009-.032.006-.023a.764.764,0,0,0,.041-.247.782.782,0,0,0-.781-.781Z",
    transform: "translate(-533.513 -187.45)",
    fill: "#1cb1e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_230",
    "data-name": "\\uADF8\\uB8F9 230",
    transform: "translate(495.048 193.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path__test",
    "data-name": "<Path>_test",
    d: "M514.946,267.247c4.6-.042,9.444-1.316,12.448-5.133,3.589-4.558,3.737-9.671,3.4-13.95-.535-6.756-2.6-12.582-6.132-16.041-2.747-2.689-5.953-3.494-9.661-3.529h-.368c-3.708.035-6.914.84-9.661,3.529-3.533,3.459-5.6,9.284-6.131,16.041-.339,4.279-.19,9.392,3.4,13.95,3,3.817,7.843,5.091,12.448,5.133Z",
    transform: "translate(-498.129 -228.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path__test-2",
    "data-name": "<Path>_test",
    d: "M511.92,225.5c3.708.035,6.913.84,9.661,3.529,3.532,3.459,5.6,9.284,6.131,16.041.338,4.279.19,9.392-3.4,13.95-3,3.817-7.843,5.091-12.448,5.133h-.259c-4.605-.042-9.444-1.316-12.448-5.133-3.589-4.558-3.737-9.671-3.4-13.95.535-6.756,2.6-12.582,6.131-16.041,2.747-2.689,5.954-3.494,9.661-3.529h.368m0-.592h-.371c-4.4.042-7.5,1.182-10.075,3.7-3.5,3.427-5.74,9.258-6.307,16.417-.331,4.184-.229,9.6,3.523,14.363,3.434,4.363,8.916,5.322,12.909,5.359h.264c4-.037,9.479-1,12.913-5.359,3.753-4.767,3.855-10.18,3.524-14.363-.567-7.159-2.807-12.989-6.308-16.417-2.571-2.516-5.676-3.657-10.069-3.7Z",
    transform: "translate(-495.048 -224.911)",
    fill: "#1cb1e2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_536",
    "data-name": "\\uD328\\uC2A4 536",
    d: "M656.277,401.969a1.108,1.108,0,1,1,.462,1.5A1.11,1.11,0,0,1,656.277,401.969Z",
    transform: "translate(-135.19 -179.521)",
    fill: "#60c5d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_537",
    "data-name": "\\uD328\\uC2A4 537",
    d: "M658.311,384.424a.928.928,0,1,1,.387,1.255A.928.928,0,0,1,658.311,384.424Z",
    transform: "translate(-136.914 -164.879)",
    fill: "#7fced9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_538",
    "data-name": "\\uD328\\uC2A4 538",
    d: "M659.533,371a.67.67,0,1,1,.279.905A.669.669,0,0,1,659.533,371Z",
    transform: "translate(-137.966 -153.731)",
    fill: "#a6dce7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_539",
    "data-name": "\\uD328\\uC2A4 539",
    d: "M530.068,233.815a12.708,12.708,0,0,1,12.88,9.982,3.594,3.594,0,0,1-.763,3.594c-1.883,1.784-4.423,2-6.229,2.234a45.781,45.781,0,0,1-5.841.407H529.7a45.8,45.8,0,0,1-5.84-.407c-1.8-.23-4.346-.45-6.228-2.234a3.593,3.593,0,0,1-.763-3.594,12.708,12.708,0,0,1,12.88-9.982Z",
    transform: "translate(-18.172 -38.908)",
    fill: "#22b7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_540",
    "data-name": "\\uD328\\uC2A4 540",
    d: "M552.084,242.717c.233.5-.609,1.389-1.881,1.983s-2.494.667-2.729.167.608-1.389,1.88-1.983S551.85,242.215,552.084,242.717Z",
    transform: "translate(-43.962 -46.099)",
    fill: "#76cce9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_541",
    "data-name": "\\uD328\\uC2A4 541",
    d: "M538.183,289.064v2.724h-1.836v.006c0,1.507.82,2.729,1.832,2.729s1.831-1.222,1.831-2.729S539.193,289.068,538.183,289.064Z",
    transform: "translate(-34.657 -85.271)",
    fill: "#035476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_542",
    "data-name": "\\uD328\\uC2A4 542",
    d: "M640.324,289.064v2.724h-1.836v.006c0,1.507.82,2.729,1.832,2.729s1.832-1.222,1.832-2.729S641.334,289.068,640.324,289.064Z",
    transform: "translate(-120.37 -85.271)",
    fill: "#035476"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_231",
    "data-name": "\\uADF8\\uB8F9 231",
    transform: "translate(506.265 206.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_543",
    "data-name": "\\uD328\\uC2A4 543",
    d: "M570.485,310.022c1.507-.018,3.577-.209,4.495-.839a2.16,2.16,0,0,0,.568-2.594,5.269,5.269,0,0,0-5.1-3.431h-.379a5.269,5.269,0,0,0-5.095,3.431,2.159,2.159,0,0,0,.568,2.594c.918.63,2.988.821,4.495.839Z",
    transform: "translate(-564.792 -303.159)",
    fill: "#d7e1e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_232",
    "data-name": "\\uADF8\\uB8F9 232",
    transform: "translate(508.178 208.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_544",
    "data-name": "\\uD328\\uC2A4 544",
    d: "M579.346,320.133a1.33,1.33,0,1,1-1.331-1.331A1.331,1.331,0,0,1,579.346,320.133Z",
    transform: "translate(-576.685 -318.802)",
    fill: "#728488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_545",
    "data-name": "\\uD328\\uC2A4 545",
    d: "M604.386,320.133a1.33,1.33,0,1,0,1.329-1.331A1.331,1.331,0,0,0,604.386,320.133Z",
    transform: "translate(-599.931 -318.802)",
    fill: "#728488"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFup);
export default __webpack_public_path__ + "static/media/FUP.b348655d.svg";
export { ForwardRef as ReactComponent };